import { useEffect, useState } from 'react';
import cloneDeep from 'lodash.clonedeep';

import normalizeTrends from '../helpers/normalizeTrends';
import sortTrends from '../helpers/sortTrends';
import getLatestDate from '../helpers/getLatestDate';

const usePerformanceTrendData = (
  data: any,
  setPeriod: any,
  compareMode: string | undefined,
  compareIds: any
): any => {
  const [trends, setTrends] = useState<any>(null);

  useEffect((): any => {
    if (!data || data.length === 0) return;
    const noData = data.filter((item: any) => item && item.length > 0);
    if (noData.length === 0) return;
    const dataCopy = cloneDeep(data);
    const normalizedTrends = normalizeTrends(dataCopy);
    const noNullDataValues = normalizedTrends[0]?.breakdown
      ? normalizedTrends
      : normalizedTrends.reduce((trends: any[], trend: any) => {
          if (!trend) return trends;
          const values = trend.data.reduce(
            (prev: any, value: any) =>
              prev.length > 0
                ? [...prev, value]
                : value.value === null
                ? prev
                : [...prev, value],
            []
          );
          trends.push({ ...trend, data: values });
          return trends;
        }, []);

    const sortedTrends = sortTrends(noNullDataValues);

    /** Order each entity in the order they are displayed in the url im compareMode. Otherwise chart colors are broken */
    const orderedTrends = compareMode
      ? compareIds.map(
          (id: string) =>
            sortedTrends.filter((trend: any) =>
              compareMode === 'entity'
                ? trend?.entity?.id === id
                : trend?.countryId === id
            )[0]
        )
      : sortedTrends;

    // get rid of undefined trends
    const filteredTrends = orderedTrends?.filter(
      (trend: any) => !!trend?.data.length
    );
    const latestDateArray = getLatestDate(filteredTrends);
    if (latestDateArray?.length) {
      setPeriod(Math.max(...latestDateArray));
    }
    setTrends(filteredTrends);
  }, [data, setPeriod, compareMode, compareIds]);

  return trends;
};

export default usePerformanceTrendData;
